module.exports = __webpack_public_path__ + "img/art-school-icon6.ac32e846.png";